import React from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { motion } from "framer-motion"
import { theme } from "../settings/config"

// Tassello del riepilogo: un'etichetta, il valore in chiaro, e sotto il dito
// la sezione che lo riguarda. Serve a far vedere tutto insieme senza aprire
// niente, e ad aprire una cosa sola quando c'è da metterci mano.
function Tile({ icon, label, value, hint, color, onClick }) {
	const accent = color ?? theme.colors.gunmetal_fill

	return (
		<motion.div
			whileTap={{ scale: onClick ? 0.97 : 1 }}
			style={{ flex: "1 1 calc(50% - 0.75rem)", minWidth: "8rem" }}>
			<Div
				bg={theme.colors.background}
				rounded="20px"
				p="0.75rem"
				h="100%"
				transition
				style={{ cursor: onClick ? "pointer" : "default" }}
				onClick={onClick}>
				<Div d="flex" align="center" m={{ b: "0.5rem" }} style={{ gap: "0.5rem" }}>
					<Div
						w="28px"
						h="28px"
						rounded="circle"
						bg={accent}
						d="flex"
						align="center"
						justify="center"
						style={{ flexShrink: 0 }}>
						<FontAwesomeIcon icon={icon} color="white" size="xs" />
					</Div>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						{label}
					</Text>
				</Div>
				<Text
					textSize="subheader"
					textWeight="bold"
					style={{
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}>
					{value}
				</Text>
				{hint && (
					<Text textSize="caption" textColor={theme.colors.text_light}>
						{hint}
					</Text>
				)}
			</Div>
		</motion.div>
	)
}

export default Tile
